<script>
    import { business, showSectionsSlider } from "../stores.js";

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

</script>

{#if $business && $business.menu.length > 2}
    <div class="slider" class:open={$showSectionsSlider}>
        <ul>
            {#each $business.menu as section, idx}
                {#if section.title}
                    <li
                        on:click={() => {
                            dispatch( 'sectionClicked', { title: section.title, idx } );
                        }}
                    >
                        {section.title}
                    </li>
                {/if}
            {/each}
        </ul>
    </div>
{/if}

<style>
    .slider {
        width: 100%;
        background: white;
        position: fixed;
        top: var(--nav-bar-height);
        z-index: 2;
        right: 0;
        box-shadow: 0 3px 10px -8px;
        transform: translateY(-100%);
        transition: transform 0.2s ease-out;
    }

    .open {
        transform: translateY(0);
    }

    ul {
        padding-top: 16px;
        padding-bottom: 12px;
        padding-left: 0;
        padding-right: 0;
        font-size: 18px;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row-reverse;
        margin: 0;
        color: white;
        overflow: auto;
        width: fit-content;
        max-width: 100vw;
        margin-left: auto;
        margin-right: auto;
    }
    @media (pointer: coarse) {
        ul::-webkit-scrollbar {
            display: none;
        }
    }

    li {
        display: inline-flex;
        background: var(--blue1);
        white-space: nowrap;
        padding: 10px 20px;
        margin-left: 10px;
        margin-right: 10px;
        border-radius: 100px;
        cursor: pointer;
    }

</style>
